import * as React from "react";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpDirtyIndicatorArrayIcon } from "../../gvc/testNewForm/CpDirtyIndicatorArrayIconLink";

interface Props {
  label: string;
  names: string[];
  showDirty?: boolean;
}
export const TabLabel: React.FC<Props> = ({ label, names, showDirty }) => {
  return (
    <div className="flex items-center cpln-editable-tab">
      <div>{label}</div>
      <CpErrorWarningArrayIcon names={names} />
      {showDirty ? <CpDirtyIndicatorArrayIcon names={names} /> : null}
    </div>
  );
};
